/**
 * MapSkeleton — full-map loading state.
 */
export default function MapSkeleton() {
  return (
    <div className="pointer-events-none absolute inset-0 z-10 flex items-end justify-center bg-parchment/60 backdrop-blur-xs">
      {/* Skeleton "hot spots" scattered across the map */}
      <div className="absolute left-1/3 top-1/4 h-24 w-24 animate-pulse-slow rounded-full bg-[#003cc5]/10 blur-2xl" />
      <div className="absolute left-2/3 top-1/3 h-32 w-32 animate-pulse-slow rounded-full bg-[#003cc5]/8 blur-3xl" style={{ animationDelay: '0.4s' }} />
      <div className="absolute left-1/4 top-1/2 h-20 w-20 animate-pulse-slow rounded-full bg-neutral-200/30 blur-2xl" style={{ animationDelay: '0.8s' }} />
      <div className="absolute left-1/2 top-2/3 h-16 w-16 animate-pulse-slow rounded-full bg-[#003cc5]/10 blur-xl" style={{ animationDelay: '1.2s' }} />

      {/* Loading label */}
      <div className="mb-24 flex items-center gap-3 rounded-xl border border-neutral-200 bg-paper/90 px-5 py-3 shadow-lg backdrop-blur-sm">
        <div className="h-4 w-4 animate-spin rounded-full border-2 border-[#003cc5] border-t-transparent" />
        <span className="text-sm text-ink">Loading map data…</span>
      </div>
    </div>
  );
}
